import { RootState } from '@app/redux/root-reducer';

export const selectAllTaskEtaState = (store: RootState) => store.etaReducer.allTaskEta;
